import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logos/ICON.png";

const FacebookIcon = () => (
  <svg
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

/**
 * Footer Component
 * - Left column: Visit Us with hours and address
 * - Center column: Logo with phone, email, CTA button
 * - Right column: Navigation menu links with Instagram feed
 */
function Footer({ restaurantData }) {
  const navigate = useNavigate();
  const hours = [
    { day: "Monday", time: "Closed" },
    { day: "Tuesday", time: "10:00am - 8:00pm" },
    { day: "Wednesday", time: "10:00am - 8:00pm" },
    { day: "Thursday", time: "10:00am - 8:00pm" },
    { day: "Friday", time: "10:00am - 8:00pm" },
    { day: "Saturday", time: "10:00am - 8:00pm" },
    { day: "Sunday", time: "10:00am - 8:00pm" },
  ];

  const navItems = [
    { label: "HOME", href: "/" },
    { label: "ABOUT", href: "#about" },
    { label: "MENU", href: "#menu" },
    { label: "CATERING", href: "#catering" },
    { label: "CONTACT", href: "#contact" },
  ];

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Left Column - VISIT US */}
          <div className="text-left">
            <h3
              className="text-lg font-bold mb-6"
              style={{ color: "#f2340a" }}
            >
              VISIT US
            </h3>
            <a
              href="https://maps.google.com/?q=677+Bergen+St+Newark+NJ+07108"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-semibold mb-4 hover:text-orange-500 transition-colors duration-200 block"
              style={{ cursor: "pointer" }}
            >
              677 Bergen St., Newark, NJ 07108
            </a>

            <h4
              className="text-sm font-bold mb-4"
              style={{ color: "#f2340a" }}
            >
              Hours of Operation
            </h4>
            <div className="space-y-1 text-sm">
              {hours.map((hour, index) => (
                <div
                  key={index}
                  className="flex justify-between"
                >
                  <span className="font-semibold uppercase">
                    {hour.day}:
                  </span>
                  <span className="text-white">{hour.time}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate("/menu")}
              className="mt-6 px-6 py-2 font-bold uppercase text-sm transition-all duration-300"
              style={{
                backgroundColor: "#f2340a",
                color: "#ffffff",
              }}
              onMouseEnter={(e) =>
                (e.target.style.opacity = "0.8")
              }
              onMouseLeave={(e) =>
                (e.target.style.opacity = "1")
              }
            >
              View Our Menu
            </button>
          </div>

          {/* Center Column - Logo & Info */}
          <div className="flex flex-col items-center justify-start">
            {/* Logo */}
            <img
              src={logo}
              alt="A Plus Flavor Logo"
              className="h-32 w-auto mb-6"
            />

            {/* Email Us Button */}
            <a
              href="mailto:info@aplusflavor.com"
              className="inline-block px-6 py-2 font-bold uppercase text-xs border-2 transition-all duration-300"
              style={{
                borderColor: "#f2340a",
                color: "#f2340a",
                backgroundColor: "transparent",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f2340a";
                e.target.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#f2340a";
              }}
            >
              Email Us
            </a>

            {/* Call Us Button */}
            <a
              href="tel:973-350-6522"
              className="inline-block px-6 py-2 font-bold uppercase text-xs border-2 transition-all duration-300"
              style={{
                borderColor: "#f2340a",
                color: "#f2340a",
                backgroundColor: "transparent",
                marginTop: "20px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f2340a";
                e.target.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#f2340a";
              }}
            >
              Call Us
            </a>

            {/* Phone */}
            <p className="text-gray-300 text-sm mb-6"></p>
          </div>

          {/* Right Column - Restaurant Name & Menu Links */}
          <div className="text-left md:text-center lg:text-right">
            <h3
              className="text-lg font-bold mb-6"
              style={{ color: "#f2340a" }}
            >
              A PLUS FLAVOR
            </h3>

            {/* Navigation Links */}
            <nav className="space-y-3 mb-8">
              {navItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="block text-white text-sm uppercase font-semibold transition-colors duration-300"
                  style={{ color: "white" }}
                  onMouseEnter={(e) =>
                    (e.target.style.color = "#f2340a")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.color = "white")
                  }
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Social Links */}
            <div className="border-t border-gray-700 pt-6">
              <p className="text-xs text-gray-400 mb-3">
                Follow Us
              </p>
              <div className="flex items-center gap-4 justify-start md:justify-center lg:justify-end">
                <a
                  href={
                    restaurantData.socialLinks?.facebook || "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-gray-400 hover:text-[#f2340a] transition-colors duration-300"
                  aria-label="Facebook"
                >
                  <FacebookIcon />
                </a>
                <a
                  href={
                    restaurantData.socialLinks?.instagram || "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-gray-400 hover:text-[#f2340a] transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Bottom Copyright */}
        <div className="text-center text-gray-400 text-sm">
          <p>
            &copy; {new Date().getFullYear()} A Plus Flavor. All
            rights reserved.
          </p>
          <p className="mt-3">
            Powered by{" "}
            <a
              href="https://www.theallardcompany.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors duration-200"
            >
              The Allard Company
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
